import React from "react";

const IMAGE_EXTS = /\.(jpg|jpeg|png|gif|webp|bmp|svg|avif|heic)$/i;
const VIDEO_EXTS = /\.(mp4|mov|avi|mkv|webm|ogg)$/i;

const getFirstFileUrl = (files) => {
  if (!files?.length) return null;
  const f = files[0];
  return f?.cloudUrl || f?.url || null;
};

const isImageUrl = (url) => url && IMAGE_EXTS.test(url.split("?")[0]);
const isVideoUrl = (url) => url && VIDEO_EXTS.test(url.split("?")[0]);

const getReplyThumbnail = (replyTo) => {
  const url = getFirstFileUrl(replyTo?.files);
  if (!url) return null;
  if (isImageUrl(url)) return { type: "image", url };
  if (isVideoUrl(url)) return { type: "video", url };
  return null;
};

const getReplyFallback = (replyTo) => {
  const fileCount = replyTo?.files?.length || 0;

  if (replyTo?.content?.trim()) {
    return replyTo.content;
  }

  if (fileCount > 0) {
    const labelByType = {
      image: "📷 Photo",
      video: "🎥 Video",
      audio: "🎵 Audio",
      sticker: "Sticker",
      file: "📎 Attachment",
    };
    return labelByType[replyTo?.messageType] || "📎 Attachment";
  }

  return "Message";
};

const ReplyPreview = ({
  replyTo,
  isOwnMessage = false,
  title,
  onClose,
  onClick,
  className = "",
}) => {
  if (!replyTo) {
    return null;
  }

  const thumbnail = getReplyThumbnail(replyTo);

  return (
    <div
      className={`chat-reply-preview ${isOwnMessage ? "chat-reply-preview-own" : ""} ${onClick ? "chat-reply-preview-link" : ""} ${className}`.trim()}
      onClick={onClick}
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={
        onClick
          ? (event) => {
              if (event.key === "Enter" || event.key === " ") {
                event.preventDefault();
                onClick(event);
              }
            }
          : undefined
      }
    >
      <div className="chat-reply-preview-bar" />
      <div className="chat-reply-preview-content">
        <strong className="chat-reply-preview-title">{title || "Reply"}</strong>
        <p className="chat-reply-preview-text mb-0">{getReplyFallback(replyTo)}</p>
      </div>
      {thumbnail && (
        <div className="chat-reply-preview-thumb">
          {thumbnail.type === "image" ? (
            <img src={thumbnail.url} alt="replied" />
          ) : (
            <div className="chat-reply-preview-thumb-video">
              <i className="bi bi-play-circle-fill"></i>
            </div>
          )}
        </div>
      )}
      {onClose && (
        <button
          type="button"
          className="chat-reply-preview-close"
          onClick={(event) => {
            event.stopPropagation();
            onClose();
          }}
          aria-label="Cancel reply"
        >
          <i className="bi bi-x-lg"></i>
        </button>
      )}
    </div>
  );
};

export default ReplyPreview;
